export default __webpack_public_path__ + "static/media/005-meat-1.f9389e50.svg";